import gql from 'graphql-tag';
import apollo from '../apollo';

export const getSocialMediaLinkValue = (links, linkName) => {
  let value = '';

  if (links === null) {
    return value;
  }

  links.forEach((socialMediaLink) => {
    if (socialMediaLink.name === linkName) {
      value = socialMediaLink.url;
    }
  });

  return value;
};

const NEW_FAMILY_TRANSFER_QUERY = gql`
  query NewFamilyTransferQuery($id: ID!) {
    account(id: $id) {
      id
      displayName
      canTransferToInFamily {
        id
        displayName
      }
    }
  }
`;

export const getAccountsToTransferToInFamily = ({ id }) => {
  const variables = {
    id,
  };

  return apollo
    .query({
      query: NEW_FAMILY_TRANSFER_QUERY,
      variables,
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => {
      const { canTransferToInFamily } = data.account;
      return canTransferToInFamily;
    });
};

export const NEW_ORGANISATION_TRANSFER_QUERY = gql`
  query NewOrganisationTransferQuery($id: ID!, $query: String) {
    account(id: $id) {
      id
      displayName
      canTransferToInOrganisation(query: $query) {
        id
        displayName
      }
    }
  }
`;

export const getAccountsToTransferToInOrganisation = ({ id, query }) => {
  const variables = {
    id,
    query,
  };

  return apollo
    .query({
      query: NEW_ORGANISATION_TRANSFER_QUERY,
      variables,
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => {
      const { canTransferToInOrganisation } = data.account;
      return canTransferToInOrganisation;
    });
};
